"use client";

import { Analytics } from '@vercel/analytics/react';

export default function VercelAnalytics() {
  // These scripts are served by the Vercel edge; off-platform they 404 and
  // log console errors, so only mount them on an actual Vercel deployment.
  if (!process.env.NEXT_PUBLIC_VERCEL_ENV) {
    return null;
  }

  return <Analytics />;
}